import SingleItemAccessTokenEditor from './SingleItemAccessTokenEditor';

export default SingleItemAccessTokenEditor;
